var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3066",
    d: "M0-682.665H88.655v88.655H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(-649 -1055)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 59,
    cy: 59,
    r: 59,
    transform: "translate(649 1055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3060",
    transform: "translate(663.673 1752.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3062",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3064",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3070",
    transform: "translate(12.978 24.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3072",
    d: "M-237.291-313.944l1.059,1.059a3.465,3.465,0,0,0,4.9,0,3.465,3.465,0,0,0,0-4.9l1.76,1.76a3.464,3.464,0,0,0,4.9,0,3.464,3.464,0,0,0,0-4.9l1.54,1.539a3.465,3.465,0,0,0,4.987-.091,3.519,3.519,0,0,0-.146-4.868l-16.643-16.643a3.465,3.465,0,0,0,4.988-.091,3.519,3.519,0,0,0-.146-4.868l-7.621-7.622a8.249,8.249,0,0,0-8.364-2.018l-3.25,1.048a2.98,2.98,0,0,1-3.021-.729l-5.533-5.533-9.351,4.2-5.471,10.624,4.731,4.731a6.57,6.57,0,0,1,1.912,5.041,6.9,6.9,0,0,0,2.01,5.3l21.8,21.8a3.519,3.519,0,0,0,4.868.146,3.465,3.465,0,0,0,.091-4.988",
    transform: "translate(272.706 360.799)",
    fill: "#fed2a4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3074",
    transform: "translate(25.553 24.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3076",
    d: "M-281.3-276.873a3.421,3.421,0,0,1-1.231.851c.512-1.275-.135-2.444-1.163-3.469l-22.261-22.318,4.835-4.909-.341-.341a8.246,8.246,0,0,0-8.364-2.017l-3.251,1.047a2.974,2.974,0,0,1-3.019-.728l-7.19-7.19,2.247-2.249,5.533,5.535a2.978,2.978,0,0,0,3.022.728l3.25-1.047a8.249,8.249,0,0,1,8.363,2.017l7.623,7.621a3.524,3.524,0,0,1,.146,4.869,3.467,3.467,0,0,1-4.989.091l16.643,16.641a3.518,3.518,0,0,1,.146,4.868",
    transform: "translate(323.289 318.195)",
    fill: "#ffbd86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3078",
    transform: "translate(51.411 56.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3080",
    d: "M-74.64-62l-1.539-1.539a3.447,3.447,0,0,1,1.015,2.449,3.442,3.442,0,0,1-.521,1.825l-9.7-9.7a1.336,1.336,0,0,1,0-1.891,1.338,1.338,0,0,1,1.892,0l8.984,8.984q-.064-.059-.128-.123",
    transform: "translate(85.78 71.25)",
    fill: "#ffbd86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3082",
    transform: "translate(43.548 58.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3084",
    d: "M-79.182-76.087a3.433,3.433,0,0,1-.524,1.83l-10.9-10.9a1.338,1.338,0,0,1,0-1.892,1.338,1.338,0,0,1,1.892,0l8.6,8.6c.014.014.029.028.041.043a3.448,3.448,0,0,1,.892,2.32",
    transform: "translate(91 87.443)",
    fill: "#ffbd86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3086",
    transform: "translate(42.368 67.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3088",
    d: "M-47.465-34.821l-1.059-1.059a3.461,3.461,0,0,1,.51,4.25,1.386,1.386,0,0,1-.212-.173l-5.931-5.931a1.338,1.338,0,0,1,0-1.892,1.336,1.336,0,0,1,1.891,0l4.887,4.887c-.029-.027-.057-.054-.086-.082",
    transform: "translate(54.549 40.018)",
    fill: "#ffbd86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3090",
    transform: "translate(18.292 56.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3092",
    d: "M-38.242-66.583l4.23-4.23a3.262,3.262,0,0,0,0-4.613l-.139-.139a3.262,3.262,0,0,0-4.613,0l-4.23,4.23a3.262,3.262,0,0,0,0,4.613l.139.139a3.262,3.262,0,0,0,4.613,0",
    transform: "translate(43.95 76.521)",
    fill: "#eb9c8d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3094",
    transform: "translate(18.449 56.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3096",
    d: "M-65.071-37.657l-4.092,4.092a3.35,3.35,0,0,1-2.376.985,3.349,3.349,0,0,1-2.376-.985,3.343,3.343,0,0,1-.869-1.5,3.377,3.377,0,0,0,.874.116,3.344,3.344,0,0,0,2.376-.985l4.092-4.09a3.36,3.36,0,0,0,.869-3.251,3.341,3.341,0,0,1,1.5.869,3.362,3.362,0,0,1,0,4.752",
    transform: "translate(74.782 43.277)",
    fill: "#d78878"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3098",
    transform: "translate(24.094 59.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3100",
    d: "M-38.241-66.583l4.23-4.23a3.263,3.263,0,0,0,0-4.613l-.139-.139a3.262,3.262,0,0,0-4.613,0l-4.23,4.23a3.262,3.262,0,0,0,0,4.613l.139.139a3.262,3.262,0,0,0,4.613,0",
    transform: "translate(43.949 76.521)",
    fill: "#eb9c8d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3102",
    transform: "translate(24.251 60.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3104",
    d: "M-65.059-37.644l-4.09,4.092a3.356,3.356,0,0,1-2.378.983,3.354,3.354,0,0,1-2.376-.983,3.323,3.323,0,0,1-.867-1.5,3.312,3.312,0,0,0,.876.118,3.35,3.35,0,0,0,2.376-.985l4.092-4.092a3.355,3.355,0,0,0,.869-3.25,3.335,3.335,0,0,1,1.5.867,3.358,3.358,0,0,1,0,4.752",
    transform: "translate(74.769 43.263)",
    fill: "#d78878"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3106",
    transform: "translate(30.454 62.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3108",
    d: "M-38.241-66.584l4.23-4.23a3.262,3.262,0,0,0,0-4.613l-.139-.139a3.263,3.263,0,0,0-4.613,0l-4.23,4.23a3.262,3.262,0,0,0,0,4.613l.139.139a3.262,3.262,0,0,0,4.613,0",
    transform: "translate(43.949 76.521)",
    fill: "#eb9c8d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3110",
    transform: "translate(30.611 63.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3112",
    d: "M-65.059-37.644l-4.092,4.092a3.349,3.349,0,0,1-2.376.985,3.35,3.35,0,0,1-2.376-.985,3.325,3.325,0,0,1-.867-1.5,3.3,3.3,0,0,0,.874.118,3.35,3.35,0,0,0,2.377-.985l4.092-4.092a3.349,3.349,0,0,0,.865-3.25,3.32,3.32,0,0,1,1.5.867,3.359,3.359,0,0,1,0,4.752",
    transform: "translate(74.769 43.263)",
    fill: "#d78878"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3114",
    transform: "translate(36.644 66.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3116",
    d: "M-38.241-66.583l4.23-4.23a3.263,3.263,0,0,0,0-4.613l-.139-.139a3.262,3.262,0,0,0-4.613,0l-4.23,4.23a3.262,3.262,0,0,0,0,4.613l.139.139a3.262,3.262,0,0,0,4.613,0",
    transform: "translate(43.949 76.521)",
    fill: "#eb9c8d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3118",
    transform: "translate(36.781 66.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3120",
    d: "M-65.2-37.788-69.294-33.7a3.347,3.347,0,0,1-2.376.983,3.347,3.347,0,0,1-2.376-.983,3.348,3.348,0,0,1-.888-1.578,3.35,3.35,0,0,0,.8.1,3.349,3.349,0,0,0,2.376-.985l4.092-4.09a3.356,3.356,0,0,0,.888-3.175,3.356,3.356,0,0,1,1.577.887,3.361,3.361,0,0,1,0,4.753",
    transform: "translate(74.933 43.428)",
    fill: "#d78878"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3122",
    transform: "translate(32.957 24.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3124",
    d: "M-287.318-99.315l-5.345-10.57-9.478-4.252-5.587,5.587a2.98,2.98,0,0,1-3.021.729l-3.25-1.048-.048-.015a6.612,6.612,0,0,0-6.484,1.514l-8.551,7.966a3.508,3.508,0,0,0-.09,5.047,3.508,3.508,0,0,0,4.864.094l3.953-3.66s2.839,1.938,5.278.984l15.9,15.9,3.151-3.152a6.9,6.9,0,0,0,2.01-5.3A6.57,6.57,0,0,1-292.1-94.53Z",
    transform: "translate(330.2 114.137)",
    fill: "#eb9c8d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3126",
    transform: "translate(61.546 36.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3128",
    d: "M-63.709-49.993a6.568,6.568,0,0,0-1.914,5.041,6.9,6.9,0,0,1-2.008,5.3L-70.783-36.5l-2.435-2.435,2.509-2.408a4.59,4.59,0,0,0,1.653-4.272c-.114-1.891.468-4.906,1.808-6.246l5.594-5.593,2.728,2.676Z",
    transform: "translate(73.217 57.455)",
    fill: "#d78878"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3130",
    transform: "translate(59.764 11.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3132",
    d: "M-191.316-124.4l-9.987,9.986a1.2,1.2,0,0,1-1.7,0l-16.515-16.515a1.2,1.2,0,0,1,0-1.7l9.986-9.986a1.2,1.2,0,0,1,1.7,0l16.515,16.515a1.2,1.2,0,0,1,0,1.7",
    transform: "translate(219.869 142.971)",
    fill: "#7acaa6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3134",
    transform: "translate(73.761 25.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3136",
    d: "M-97.357-30.792l-9.935,9.936a1.239,1.239,0,0,1-1.751,0l-2.844-2.846a1.237,1.237,0,0,0,1.75,0l9.937-9.935a1.239,1.239,0,0,0,0-1.751l2.844,2.844a1.239,1.239,0,0,1,0,1.752",
    transform: "translate(111.888 35.388)",
    fill: "#57be92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3138",
    transform: "translate(-0.015 11.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3140",
    d: "M-2.359-124.4l9.987,9.986a1.2,1.2,0,0,0,1.7,0l16.515-16.515a1.2,1.2,0,0,0,0-1.7l-9.986-9.986a1.2,1.2,0,0,0-1.7,0L-2.359-126.1a1.2,1.2,0,0,0,0,1.7",
    transform: "translate(2.711 142.971)",
    fill: "#528fd8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3142",
    transform: "translate(14.268 11.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3144",
    d: "M-95.437-80.73l-2.557,2.557a1.239,1.239,0,0,0,0-1.751l-9.935-9.935a1.239,1.239,0,0,0-1.751,0l2.558-2.557a1.239,1.239,0,0,1,1.751,0l9.935,9.935a1.236,1.236,0,0,1,0,1.751",
    transform: "translate(109.681 92.778)",
    fill: "#0573ce"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionIcon);
export default __webpack_public_path__ + "static/media/visionIcon.b8e26d6eb0bd44e242a70a33da76de60.svg";
export { ForwardRef as ReactComponent };